import { useSearchPageSlicedProducts } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
import { useSearchPageHasResponse } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageHasResponse";
import { useSearchPagePrunedQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPagePrunedQuery";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
export var useSearchPageExactSearchReturnedNoResults = function() {
    var hasResponse = useSearchPageHasResponse();
    var isLoading = useSearchPageQueryIsLoading();
    var prunedQuery = useSearchPagePrunedQuery();
    var products = useSearchPageSlicedProducts();
    if (!hasResponse || isLoading) {
        return false;
    }
    return !!prunedQuery || !(products === null || products === void 0 ? void 0 : products.length);
};
